import gql from "graphql-tag";

export default gql`
  fragment workflowStatusParts on WorkflowStatus {
    id
    name
    actionName
    position
    initial
    color {
      id
      color
      saturation
    }
    attendancePlaces {
      ...attendancePlaceParts
    }
    nextStatuses {
      id
      name
    }
  }
`;
